module.exports = __webpack_public_path__ + "startpage-746fed5a/google-play-badge-de-93785b1e1a272e0a50d1146c1fd11bc1.svg";